

<div class="page" [ngClass]="loader.searchFlag == true ? 'searchClass':''" >
  <div class="headerbox">	
    <mat-toolbar class="example-toolbar">
      <button (click)="isExpanded = !isExpanded" class="menuicon1">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="eva eva-menu-2-outline" fill="currentColor"><g data-name="Layer 2"><g data-name="menu-2"><rect width="24" height="24" transform="rotate(180 12 12)" opacity="0"></rect><circle cx="4" cy="12" r="1"></circle><rect x="7" y="11" width="14" height="2" rx=".94" ry=".94"></rect><rect x="3" y="16" width="18" height="2" rx=".94" ry=".94"></rect><rect x="3" y="6" width="18" height="2" rx=".94" ry=".94"></rect></g></g></svg>
      </button>
      <app-header class="mainheader"></app-header>
    </mat-toolbar>
  </div>	
  <div   class="navbox">
  <mat-sidenav-container  class="example-container" autosize>
    <mat-sidenav #sidenav class="example-sidenav" mode="side" opened="true" >
      <mat-nav-list>
        <ng-container *ngFor="let menu of sidebarnavItems">

          <mat-list-item *ngIf="menu?.submenu?.length == 0" [ngClass]="[menu.class]" (click)="navigateToPage('main',menu,{})" class="parent">
            <span class="full-width text" [ngClass]="menuClass == menu.title ? 'Active' : ''" *ngIf="isExpanded || isShowing" > {{menu.title}} </span>
            <mat-icon mat-list-icon [ngClass]="menuClass == menu.title ? 'Active' : ''" class="material-icons"> {{menu.icon}}  </mat-icon>
          </mat-list-item>


          <mat-list-item *ngIf="menu?.submenu?.length > 0" [ngClass]="[menu.class]" [ngStyle]="{'min-width':isExpanded == true ? '250px' : '' }"  (click)="openSubMenu(menu)" class="parent">
            <span class="full-width text" [ngClass]="menuClass == menu.title ? 'Active' : ''" *ngIf="isExpanded || isShowing"> {{menu.title}} </span>
            <mat-icon mat-list-icon [ngClass]="menuClass == menu.title ? 'Active' : ''" class="material-icons ">
                {{menu.icon}}
            </mat-icon>				
            <mat-icon class="menu-button" [ngClass]="{'rotated' : menu.expand}" *ngIf="isExpanded || isShowing">expand_more</mat-icon>
          </mat-list-item>
          <div class="submenu"[ngClass]="{'expanded' : menu.expand}" [hidden]="!menu.expand"  *ngIf="(isShowing || isExpanded)">
            <a mat-list-item *ngFor="let submenu of menu.submenu"  [ngClass]="[submenu.class]" [ngClass]="subMenuClass == submenu.title ? 'Active' : ''"  (click)="navigateToPage('sub',menu,submenu)" > {{submenu?.title}} </a>
          </div>	
            

          
        </ng-container>
        
      
      </mat-nav-list>
    </mat-sidenav>
    <div class="contentbox">
      <div class="page-container">
      <router-outlet>
      </router-outlet>
      </div>
      <app-footer>
      </app-footer>
    </div>
    
  
  </mat-sidenav-container>
  </div>
  </div>
  













  <div  class="search" [ngClass]="loader.searchFlag == true ? 'searchNew':'searchOld'">
    <button class="button"  >
      <mat-icon class="menu-button" (click)="closeSearch()">close</mat-icon>
      </button>
      <div class="form-wrapper">
        <form class="form ng-untouched ng-pristine ng-valid">
          <div class="form-content">
            <input autocomplete="off" tabindex="-1" class="search-input" placeholder="Search...">
          </div>
          <span class="info">Hit enter to search</span>
        </form>
      </div>
    </div>


  
  
  <!-- Copyr	ight 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->